import { createContext } from 'react';
import type { API } from '@trinity/chat';

export type GetProjectQuantAnalysisAPI = (
  data: API.ProjectsQuantAnalysis.GetProjectQuantAnalysis.Request
) => Promise<API.ProjectsQuantAnalysis.GetProjectQuantAnalysis.Response>;

export type GetProjectQuantAnalysisVersionsAPI = (
  data: API.ProjectsQuantAnalysis.GetProjectQuantAnalysisVersions.Request
) => Promise<API.ProjectsQuantAnalysis.GetProjectQuantAnalysisVersions.Response>;

export type QuantAnalysisAPIContextValue = {
  getProjectQuantAnalysis: GetProjectQuantAnalysisAPI;
  getProjectQuantAnalysisVersions: GetProjectQuantAnalysisVersionsAPI;
};

export const QuantAnalysisAPIContext = createContext<QuantAnalysisAPIContextValue | null>(null);

QuantAnalysisAPIContext.displayName = 'QuantAnalysisAPIContext';
